import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { GeneralExpenseReport } from './GeneralExpenseReport';

export const GeneralExpenseReportPage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <GeneralExpenseReport />
    </PageContainer>
  );
};
